var exports = {
  "k": "xb99ab02a--38ca39--container",
  "K": "xb99ab02a--38ca39--full-height-image",
};

module.exports = exports;
